export default __webpack_public_path__ + "static/media/telefon_grün.333300ff.png";